exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".options-tree[data-v-754d1f9e]::-webkit-scrollbar{width:6px}.options-tree[data-v-754d1f9e]  .el-tree-node__content{height:36px}", ""]);

// exports
